import api from "../../api/database";
import Vue from 'vue'

const state = {
    metricData: false,
    programData: false,
    program: '',
    year: '',
    updationProgress: false,
    editProgramLoading: false
}

const getters = {
    currentMetricData:state => state.metricData,
    programData:state => state.programData,
    updationProgressStatus:state => state.updationProgress,
    editProgramLoadingState: state => state.editProgramLoading,
    // metric_category
}

const actions = {
    updateGetMetricParams({commit},model){
        commit('setProgram', model.program);
        commit('setYear', model.year);
    },
    async getMetricData({commit}){
        const response = await api.getMetricData(state.program, state.year);
        if(response && response['data']['status'] == "success"){
            console.log(`Success: `, response)
            console.log(`data: ${JSON.stringify(response['data']['data'])}`)
            commit('setMetricData', response['data']['data']['Item']['tracked_metrics'] ? response['data']['data']['Item']['tracked_metrics'] : [])
        } else {
            console.log('Logging error: Getting Menu Options')
            console.log(response)
            Vue.notify({
                group: 'error',
                text: 'Unable to Fetch Metric Data...',
                closeOnClick:true
              })
        }
    },
    async getProgramData({commit}, year){
        const response = await api.getProgramDataForYear(year);
        if(response && response['data']['status'] == "success"){
            console.log(`Success: `, response)
            console.log(`data: ${JSON.stringify(response['data']['data'])}`)
            commit('setProgramData', response['data']['data'])
        } else {
            console.log('Logging error: Getting Menu Options')
            console.log(response)
            Vue.notify({
                group: 'error',
                text: 'Unable to Fetch Metric Data...',
                closeOnClick:true
              })
        }
    },
    async editTargetData({commit, dispatch}, data){
        commit('setUpdationProgess', true);
        const response = await api.editMetricTarget(data, state.program, state.year);
        console.log(response)
        if(response && response['data']['status'] == "success"){
            commit('setUpdationProgess', false);
            Vue.notify({
                group: 'success',
                text: 'Updated the Target...',
                closeOnClick:true
              })
            await dispatch('getMetricData');
        } else {
            var message =  'Unable to update the Metric Target...'
            commit('setUpdationProgess', false);
            if(response && response['data']['message']) {
               message = response['data']['message']
            }
            Vue.notify({
                group: 'error',
                text: message,
                closeOnClick:true
              })
        }
    },
    async editMetricData({commit, dispatch}, data){
        const response = await api.editDecimal(data, state.program, state.year);
        if(response && response['data']['status'] == "success"){
            Vue.notify({
                group: 'success',
                text: 'Updated the Metric data...',
                closeOnClick:true
              })
            await dispatch('getMetricData');
        } else {
            var message =  'Unable to update the Metric data...'
            if(response && response['data']['message']) {
               message = response['data']['message']
            }
            Vue.notify({
                group: 'error',
                text: message,
                closeOnClick:true
              })
        }
    },
    async editProgramName({commit, dispatch}, data){
        try {
            commit('setEditProgramLoading', true);
            const response = await api.editProgramName(data);
            if(response && response['data']['status'] == "success"){
                console.log(`Success: `, response)
                Vue.notify({
                    group: 'success',
                    text: 'Updated the Program name...',
                    closeOnClick:true
                  })
                  commit('setEditProgramLoading', false);
                await dispatch('getProgramData', state.year);
            } else {
                console.log('Logging error: Getting Menu Options')
                commit('setEditProgramLoading', false);
                console.log(response)
                Vue.notify({
                    group: 'error',
                    text: 'Unable to Update the Program name..',
                    closeOnClick:true
                  })
             }
        } catch (e) {
            commit('setEditProgramLoading', false);
            console.log(e);
        }
    },
    async editMetricsStatus({commit, dispatch}, data){
        const response = await api.editMericsStatus(data, state.program, state.year);
        if(response && response['data']['status'] == "success"){
            console.log(`Success: `, response)
            Vue.notify({
                group: 'success',
                text: 'Updated the Metric status...',
                closeOnClick:true
              })
            await dispatch('getMetricData');
            // console.log(`data: ${JSON.stringify(response['data']['data'])}`)
            // commit('setMetricData', response['data']['data']['Item']['tracked_metrics'])
        } else {
            console.log(response)
            Vue.notify({
                group: 'error',
                text: 'Unable to Update the Metric status...',
                closeOnClick:true
              })
           }
    },
    async editProgramStatus({commit, dispatch}, data){
        const response = await api.editProgramStatus(data, state.program, state.year);
        dispatch('resetOverlay');
        if(response && response['data']['status'] == "success"){
            console.log(`Success: `, response)
            Vue.notify({
                group: 'success',
                text: 'Updated the Program as ' + data.program_status,
                closeOnClick:true
              })
              await dispatch('getProgramData', state.year);
        } else {
            console.log(response)
            Vue.notify({
                group: 'error',
                text: 'Unable to Update the Program as ' + data.program_status,
                closeOnClick:true
              })
           }
        }
    }

const mutations = {
    setMetricData: (state,data) => {
        state.metricData = data;
    },
    setProgramData: (state, data) => {
        state.programData = data;
    },
    setProgram: (state, data) => {
        state.program = data;
    },
    setYear: (state, data) => {
        state.year = data;
    },
    setUpdationProgess: (state, data) => {
        state.updationProgress = data;
    },
    setEditProgramLoading: (state, data) => {
        state.editProgramLoading = data;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
